import { createAsyncThunk } from "@reduxjs/toolkit";
import { supportAndPlans } from "store/services/supportAndPlans";

export const supportPost = createAsyncThunk(
  "portal/support",
  async (params: any) => {
    return await supportAndPlans(params);
  }
);
